import { FaInstagramSquare, FaTwitterSquare, FaFacebookSquare } from 'react-icons/fa';

function Footer() {
  const style = { color: '#962c30', fontSize: '1.6em' };
  return (
    <div className="container">
      <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
        <div className="col-md-6 d-flex align-items-center">
          <span className="text-muted">
            Copyright © 2023 National Social Security Fund - Member Self Service Portal
          </span>
        </div>

        <ul className="nav col-md-4 justify-content-end list-unstyled d-flex">
          <li className="ms-3"><a className="text-muted" href="https://twitter.com/nssftz">
            <FaTwitterSquare style={style}/>
          </a></li>
          <li className="ms-3"><a className="text-muted" href="https://www.instagram.com/nssftz/channel/">
            <FaInstagramSquare style={style}/>
          </a></li>
          <li className="ms-3"><a className="text-muted" href="https://www.facebook.com/Nssftz/">
            <FaFacebookSquare style={style}/>
          </a></li>
        </ul>
      </footer>
    </div>
  );
}

export default Footer;
